import { IntlShape } from "react-intl";

import { Translate } from "../hooks/useTranslation";

export const getGenericRequiredError = (intl: IntlShape) => ({
  required: intl.formatMessage({ id: "generic-input.error" }),
});

export const getGenericRequiredErrorV2 = (t: Translate) => ({
  required: t("generic-input.error"),
});
